// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__Y_eFW"};